import { crossTabChannel } from 'src/auth/syncSession'
import { useLocalStorage } from 'src/hooks/useLocaleStorage'

import UserActions, { UserAction } from './actions'
import initialUserState from './initialState'
import { UserState } from './types'

const UserReducer = (UserState: UserState | never, action: UserAction): UserState | never => {
    const {
        getFromStorage: getFromLocalStorage,
        saveToStorage: saveToLocalStorage,
        removeFromStorage: removeFromLocalStorage,
    } = useLocalStorage()

    switch (action.type) {
        case UserActions.INIT: {
            const state = getFromLocalStorage('user') || {}
            return { ...UserState, ...state }
        }
        case UserActions.LOG_IN: {
            const newLocalState = { ...UserState, authenticated: true, unAuthorized: false }

            saveToLocalStorage('user', newLocalState)

            return newLocalState
        }
        case UserActions.SET_USER_INFO: {
            const { id, username, firstName, lastName, roles, permissions } = action.payload

            const newState = {
                ...UserState,
                info: { ...UserState.info, id, username, firstName, lastName, permissions, roles },
            }

            saveToLocalStorage('user', newState)

            return newState
        }
        case UserActions.SET_DEALER: {
            const newState = {
                ...UserState,
                dealer: action.payload.dealer,
            }

            saveToLocalStorage('user', newState)

            return newState
        }
        case UserActions.SET_BUSINESS_UNIT: {
            const newState = {
                ...UserState,
                businessUnit: action.payload.businessUnit,
                businessUnitBrand: initialUserState.businessUnitBrand,
            }

            saveToLocalStorage('user', newState)

            return newState
        }
        case UserActions.SET_BUSINESS_UNIT_BRAND: {
            const newState = {
                ...UserState,
                businessUnitBrand: action.payload.businessUnitBrand,
            }

            saveToLocalStorage('user', newState)

            return newState
        }

        case UserActions.LOG_OUT: {
            removeFromLocalStorage('user')
            crossTabChannel.postMessage({ request: 'logout' })

            return initialUserState
        }

        case UserActions.CANCEL_LOG_IN: {
            return {
                ...UserState,
                authenticated: false,
                info: { ...initialUserState.info },
            }
        }

        case UserActions.RESET_SESSION: {
            removeFromLocalStorage('user')
            sessionStorage.removeItem('user')
            crossTabChannel.postMessage({ request: 'logout' })

            return initialUserState
        }

        default: {
            throw Error('Unknown action: ' + action.type)
        }
    }
}

export default UserReducer
